import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import EditTripForm from './EditTripForm';
import { CircularProgress, Alert, Box } from '@mui/material';
import { API_BASE_URL } from './config';
import { useTranslation } from 'react-i18next';

const EditTripPage = ({ setIsAiWorking }) => {
    const { t } = useTranslation();
    const { tripId } = useParams();
    const navigate = useNavigate();
    const [trip, setTrip] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchTrip = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem('token');
                const response = await fetch(`${API_BASE_URL}/trips/get_single.php?trip_id=${tripId}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                if (response.ok) {
                    const data = await response.json();
                    setTrip(data);
                } else if (response.status === 404) {
                    // Trip not found, redirect to home
                    navigate('/');
                    return;
                } else {
                    const errorData = await response.json();
                    setError(errorData.message || t('fetch_trip_edit_error'));
                }
            } catch (err) {
                setError(t('fetch_trip_details_general_error'));
            } finally {
                setLoading(false);
            }
        };

        fetchTrip();
    }, [tripId, t, navigate]);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return <Alert severity="error" sx={{ m: 2 }}>{error}</Alert>;
    }

    if (!trip) {
        return <Alert severity="info" sx={{ m: 2 }}>{t('no_trip_details')}</Alert>;
    }

    return (
        <EditTripForm 
            trip={trip} 
            tripId={tripId}
        />
    );
};

export default EditTripPage;
